export const todayStr = () => new Date().toISOString().split('T')[0];

export const computeDateRange = (range) => {
    const today = new Date();
    const to = todayStr();
    if (range === 'all') return {from: undefined, to: undefined};
    let from;
    if (range === 'this-month') {
        from = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0];
    } else if (range === 'last-3-months') {
        const d = new Date(today);
        d.setMonth(d.getMonth() - 3);
        from = d.toISOString().split('T')[0];
    } else if (range === 'this-year') {
        from = new Date(today.getFullYear(), 0, 1).toISOString().split('T')[0];
    }
    return {from, to};
};

export const formatGroupDate = (dateStr) =>
    new Intl.DateTimeFormat(undefined, {
        weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
    }).format(new Date(dateStr + 'T00:00:00'));